import { Flex, Typography } from "antd";
import styled from "styled-components";

export const BusinessDayWorkingHoursContainer = styled(Flex)(({ theme }) => ({
  gap: theme.spacing,
  justifyContent: "space-between",
  color: "rgba(0,0,0,0.45)",

  "&[data-current='true']": {
    color: "rgba(0,0,0,0.88)",
  },
}));

export const Text = styled(Typography.Text)({
  textTransform: "capitalize",
  color: "inherit",
});
